// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_f552cc8"};